module.exports = __webpack_public_path__ + "static/img/training_system_s5_max2.53c5929b.png";